// @ai-generated 2026-07-10T00:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5
import { FlexColumn, Grid, GridColumns, TextInputBase, useTranslate } from '@synqo/frontend-component-library';

export interface SiteContactDraft {
    firstName: string;
    lastName: string;
    phone: string;
}

interface SiteContactFieldsProps {
    /** Prefix for input `name` attributes, so two instances on one page stay unique. */
    idPrefix: string;
    value: SiteContactDraft;
    onChange: (patch: Partial<SiteContactDraft>) => void;
    autoFocusOnRender?: boolean;
}

/**
 * Vorname/Nachname/Telefon fields for an on-site contact — shared between the inline
 * "neuen Ansprechpartner anlegen" picker form and the "Neue Anschrift anlegen" modal, so
 * both flows capture the same contact snapshot shape.
 */
export function SiteContactFields({ idPrefix, value, onChange, autoFocusOnRender }: SiteContactFieldsProps) {
    const i18n = useTranslate('');

    const updateField = (key: keyof SiteContactDraft) => (fieldValue: string) => {
        onChange({ [key]: fieldValue });
        return true;
    };

    return (
        <FlexColumn gap="sm" width="100%">
            <Grid columns={3} gutter="sm" fullWidth>
                <GridColumns spans={[1, 1, 1]}>
                    <TextInputBase
                        name={`${idPrefix}_first_name`}
                        label={i18n('Vorname')}
                        value={value.firstName}
                        onChange={updateField('firstName')}
                        autoFocusOnRender={autoFocusOnRender}
                    />
                    <TextInputBase
                        name={`${idPrefix}_last_name`}
                        label={i18n('Nachname')}
                        value={value.lastName}
                        onChange={updateField('lastName')}
                    />
                    <TextInputBase
                        name={`${idPrefix}_phone`}
                        label={`${i18n('Telefon')} (${i18n('optional')})`}
                        value={value.phone}
                        onChange={updateField('phone')}
                    />
                </GridColumns>
            </Grid>
        </FlexColumn>
    );
}
